export async function getDeviceInfo() {
  let ipAddress = 'Unknown IP'
  let deviceType = 'Unknown Device'

  // Get Public IP Address
  try {
    const response = await fetch('https://api64.ipify.org?format=json')
    const data = await response.json()
    ipAddress = data.ip
  } catch (error) {
    console.error('Error fetching IP:', error)
  }

  // Get Device/System Name
  const { userAgent } = navigator
  deviceType = userAgent
  return { ipAddress, deviceType }
}
export default getDeviceInfo
